import { useSelectedProductStoreBase } from 'stores/selectedProduct/selectedProduct.store';
import type { TickerData } from 'types/Ticker';

const updateSelectedProductSpot = (data: { symbol: string; price: string }) => {
  useSelectedProductStoreBase.getState().actions.updateSpotPrice(Number(data.price));
};

const setSelectedProductMarkData = (data: {
  product_id: number;
  price: string;
  price_band: TickerData['price_band'];
  implied_volatility: string;
}) => {
  useSelectedProductStoreBase.getState().actions.updateMarkPrice(data);
};

const updateSelectedCoinSpotPrice = (data: { p: number }) => {
  useSelectedProductStoreBase.getState().actions.updateSelectedCoinSpotPrice(data);
};

const updateSelectedCoinIndexSymbol = (data: { symbol: string }) => {
  useSelectedProductStoreBase.getState().actions.updateSelectedCoinIndexSymbol(data);
};

const updateSelectedProductFundingData = (data: {
  predicted_funding_rate: string;
  funding_rate: string;
  next_funding_realization: string;
  funding_interval: string;
}) => {
  useSelectedProductStoreBase.getState().actions.updateProductFundingData(data);
};

export {
  updateSelectedProductSpot,
  setSelectedProductMarkData,
  updateSelectedCoinSpotPrice,
  updateSelectedCoinIndexSymbol,
  updateSelectedProductFundingData,
};
